import angular from 'angular';
import toolbarService from "../../../../Toolbar/ToolbarService";
import sectionsLibraryService from "../../../SectionsLibraryService";
import workspaceElement from "../../../../Workspace/WorkspaceElement/WorkspaceElement";
import columnResizer from "./ColumnResizer/ColumnResizer";

import './Section.scss';
import Paddings from "../../../../ConfigParameters/ConfigCollections/Paddings";
import Backgrounds from "../../../../ConfigParameters/ConfigCollections/Backgrounds";
import ColumnsBackgroundColor from "../../../../ConfigParameters/ConfigParameters/ColumnsBackgroundColor";
import Children from "../../../../ConfigParameters/ConfigParameters/Children";
import ColumnsWidth from "../../../../ConfigParameters/ConfigParameters/ColumnsWidth";
import FullWidth from "../../../../ConfigParameters/ConfigParameters/FullWidth";
import PinSection from "../../../../ConfigParameters/ConfigParameters/PinSection";
import ConfigParameter from "../../../../ConfigParameters/ConfigParameter";
import Animation from "../../../../ConfigParameters/ConfigParameters/Animation";
import Anchor from "../../../../ConfigParameters/ConfigParameters/Anchor";
import Parallax from "../../../../ConfigParameters/ConfigParameters/Parallax";
import CustomClassName from "../../../../ConfigParameters/ConfigParameters/CustomClassName";

const MODULE_NAME = 'pageSection';

const creatorPageSection = {
    bindings: {
        elementModel: '=',
        context: '<',
        content: '=',
        uid: '<'
    },
    template: require('./section.html'),
    controller: function (ToolbarService) {

        let defaultConfig = ToolbarService.getSectionDefaultSchema(MODULE_NAME);

        this.$onInit = () => {
            this.elementModel = angular.copy(angular.extend(defaultConfig, this.elementModel));
        };

    }
};

export default angular.module(
    'cms.creator.page.section',
    [sectionsLibraryService, toolbarService, workspaceElement, columnResizer]
    ).run(function (SectionsLibraryService, ToolbarService, UniqueIdGenerator, gettext
) {

    SectionsLibraryService.registerSection({
        icon: 'view_column',
        type: MODULE_NAME,
        label: gettext('Section'),
        group: 'page',
        groups: {
            mainConfig: {
                label: gettext('Main config'),
                isOpen: true,
                type: 'mainConfig'
            },
            position: {
                label: gettext('Position'),
                isOpen: false,
                type: 'position'
            },
            advanced: {
                label: gettext('Advanced'),
                isOpen: false,
                type: 'advanced'
            }
        }
    });

    ToolbarService.registerSectionSchema(MODULE_NAME, {
        ...(new ConfigParameter('uid', 'hidden',  '', null, () => UniqueIdGenerator.generate('element-uid'))),
        ...(new Children()),
        ...(new ColumnsWidth()),
        ...(new Backgrounds()),
        ...(new ColumnsBackgroundColor()),
        ...(new Paddings()),
        ...(new FullWidth()),
        ...(new PinSection()),
        ...(new Animation()),
        ...(new Parallax()),
        ...(new Anchor()),
        ...(new CustomClassName())
    });

    })
    .component('cmsCreatorPageSection', creatorPageSection).name;




// WEBPACK FOOTER //
// ./src/cmsCore/Creator/SectionsLibrary/Sections/Page/Section/Section.js